<template>
    <div class="q-px-none q-pt-none q-pb-sm" style="width:100%">
        <div v-if="rules[0]" style="width:100%">
            <div class="threshold-rule-row">
                <span class="threshold-rule-prefix text--primary">{{ Translate('If') }}</span>
                <div class="threshold-rule-field threshold-rule-operator-field">
                    <q-select outlined dense bg-color="white"
                            :label="Translate('Operator')"
                            v-model="rules[0].operator"
                            :options="condition_types"
                            option-label="text"
                            option-value="value"
                            emit-value
                            map-options
                            @update:model-value="updateReport"
                            hide-bottom-space
                            class="full-width"
                            :error="hasOperatorError"></q-select>
                </div>

                <div class="threshold-rule-field threshold-rule-value-field"
                     v-if="!(rules[0].operator == 'empty' || rules[0].operator == 'notEmpty' || rules[0].operator == 'missing')">
                    <q-input outlined dense bg-color="white"
                             :label="Translate('Value')"
                             v-model="rules[0].value"
                             @update:model-value="updateReport"
                             hide-bottom-space
                             class="full-width"
                             :error="hasValueError"></q-input>
                </div>

                <span class="threshold-rule-then text--primary">{{ Translate('then') }}</span>
                <div class="threshold-rule-format-field">
                    <ThresholdformatOptions ref="formatOptions"
                        :EventBus="EventBus"
                        :defaultColor="value.color"
                        @thresholdFormatChanged="thresholdFormatChanged"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import methods from '@/Shared/methods';
    import ThresholdformatOptions from './threshold_formatOptions.vue';
    import common from './common.js';

    export default {
        components: {
            ThresholdformatOptions
        },
        // Declare so parent listeners are component emits (Vue 3); same pattern as filter_*.vue (CCDEV-18136).
        emits: ['thresholdValuesChanged', 'thresholdFormatChanged'],
        data: function () {
            return {
                rules: [{ operator: 'contains', value: '', combiner: undefined }],
                hasOperatorError: false,
                hasValueError: false,
            }
        },
        props: {
            item: Object,
            value: null,
            EventBus: null
        },
        created() {
            if (this.value)
            {
                console.log(`threshold_searchableTextColumn has received an initialValue of ${JSON.stringify(this.value)}`);
            }
            const self = this;
            this.updateReportDebouncer = _.debounce(function () {
                if (self.rules[0].operator == 'missing' || self.rules[0].operator == 'empty' || self.rules[0].operator == 'notEmpty')
                {
                    self.rules[0].value = "";
                }

                if (self.rules.length == 1)
                {
                    // Single rule scenario is the simplest format (made popular by ag-grid)
                    self.$emit('thresholdValuesChanged', {
                        filterType: "text",
                        operator: self.rules[0].operator,
                        filter: self.rules[0].value,
                        value: self.rules[0].value,
                        type: "searchableText"
                    });
                }
                else
                {
                    // Multiple rule scenario puts the conditions into an array
                    self.$emit('thresholdValuesChanged', {
                        filterType: "text",
                        operator: self.rules[0].combiner,
                        type: "searchableText",
                        conditions: self.rules.map(a => ({
                            type: a.condition,
                            filter: a.value,
                        }))
                    });
                }

            }, 500);
            if (this.value && this.value.type) {
                this.rules = [{
                    operator: this.value.operator,
                    value: this.value.value,
                }];
            }
            else if (this.value && this.value.conditions && this.value.conditions.length == 2) {
                this.rules = [{
                    condition: this.value.conditions[0].operator,
                    value: this.value.conditions[0].value,
                    combiner: this.value.operator,
                }, {
                    condition: this.value.conditions[1].operator,
                    value: this.value.conditions[1].value,
                }];
            }
        },
        watch: {
            rules: function (newv) {
                this.updateReport();
            },
        },
        computed: {
            condition_types: function () {
                return [
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Contains'), value: 'contains' },
                    { text: this.Translate('Does Not Contain'), value: 'notContains' },
                    { text: this.Translate('Begins With'), value: 'beginsWith' },
                    { text: this.Translate('Ends With'), value: 'endsWith' },
                    { text: this.Translate('Blank'), value: 'empty' },
                    { text: this.Translate('Not Blank'), value: 'notEmpty' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            valueRules() {
                return [
                    v => !!v || this.Translate('Please enter a value')
                ];
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },
        },
        methods: {
            ...methods,
            updateReport() {
                this.updateReportDebouncer();
            },
            setItemCombiner(item, index, value) {
                item.combiner = value;
                this.updateReport();
            },
            addCondition() {
                this.rules.push({ operator: 'contains', value: '', combiner: undefined });
            },
            removeCondition() {
                this.rules.pop();
            },
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            triggerValidation() {
                const rule = this.rules[0];
                this.hasOperatorError = common.hasValidationError(this.operatorRules, rule.operator);
                this.hasValueError = false;

                if (!(rule.operator == 'empty' || rule.operator == 'notEmpty' || rule.operator == 'missing'))
                    this.hasValueError = common.hasValidationError(this.valueRules, rule.value);
            },
            validate() {
                this.triggerValidation();
                const formatValid = this.$refs.formatOptions?.validate?.() ?? true;
                const hasErrors = this.hasOperatorError || this.hasValueError;
                return !hasErrors && formatValid;
            },
        }
    }
</script>

<style src="./threshold_row.css"></style>

<style scoped>
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

    .customHoverButton:hover {
        filter: brightness(80%);
    }
</style>
